export function computeLocalStorageBytes(storage: Storage = localStorage): number {
  try {
    const encoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null
    let total = 0
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i) || ''
      const value = storage.getItem(key) || ''
      if (encoder) {
        total += encoder.encode(key).length + encoder.encode(value).length
      } else {
        // Fallback approximation if TextEncoder is unavailable
        total += key.length + value.length
      }
    }
    return total
  } catch {
    return 0
  }
}

export function clearLocalStorageIfNeeded(): boolean {
  const LIMIT_BYTES = 4.5 * 1024 * 1024 // ~4.5MB
  const current = computeLocalStorageBytes(localStorage)
  if (current <= LIMIT_BYTES) return false
  else {
    console.warn('Clearing all localStorage since it exceeds limit...')
    localStorage.clear()
    return true
  }
}
